import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/utils/api';

export const useAvailableLoads = () => useQuery({
  queryKey: ['fun-jumper', 'available-loads'],
  queryFn: () => api.get('/manifest/loads/available').then(r => r.data.data),
  refetchInterval: 20_000,
});

export const useMyManifestStatus = () => useQuery({
  queryKey: ['fun-jumper', 'my-status'],
  queryFn: () => api.get('/fun-jumper/my-status').then(r => r.data.data),
  refetchInterval: 15_000,
});

export const useEligibility = (jumpType = 'fun-jump') => useQuery({
  queryKey: ['fun-jumper', 'eligibility', jumpType],
  queryFn: () => api.get(`/fun-jumper/eligibility?jumpType=${jumpType}`).then(r => r.data.data),
});

export const useSelfManifest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/fun-jumper/self-manifest', data).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fun-jumper'] });
    },
  });
};

export const useSelfRemove = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (loadId) => api.delete(`/fun-jumper/self-manifest/${loadId}`).then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fun-jumper'] });
    },
  });
};
